<template>
<div class="acc-root-sty">
  <el-tabs v-model="activeName">
    <el-tab-pane label="给第三方平台的授权" name="first">
      <el-table
        v-loading="tableLading"
        :data="tableData"
        style="border: 1px solid #eeeeee; border-bottom: 0"
        tooltip-effect="dark"
        :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '600',
              }"
      >
        <!--    <el-table-column label="授权人">-->
        <!--      <template slot-scope="scope">-->
        <!--        <span>{{allAuthUser.accountInfoVO.name}}</span>-->
        <!--      </template>-->
        <!--    </el-table-column>-->
        <el-table-column
          prop="granteeUserName"
          label="被授权人"
          width="180">
        </el-table-column>
        <el-table-column
          prop="granteeAccount"
          label="被授权账号">
        </el-table-column>
        <el-table-column
          prop="granteeIdNo"
          label="被授权人证件号">
        </el-table-column>
        <el-table-column
          prop="grantTime"
          label="授权时间">
        </el-table-column>
        <el-table-column
          prop="scopes"
          label="授权范围">
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              trigger="hover"
            >
              <div style="padding: 10px">
                <p>被授权人 获取 授权人 账号基本信息</p>
                <p>被授权人 为 授权人 账号申请数字证书</p>
                <p>被授权人 代 授权人 账号发起、签署合同</p>
                <p>被授权人 存储 授权人 账号的合同文件</p>
              </div>
              <el-button slot="reference" type="text" size="small" style="color: #ec1c1c">查看范围</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="link-option" @click="handleLift(scope.row)">解除授权</el-button>
          </template>
        </el-table-column>
        <no-data text="暂无数据" slot="empty" />
      </el-table>
      <!--分页-->
      <el-row class="pageation row">
        <el-col :span="24" class="page-flex-end">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="pageSize"
            layout="prev, pager, next, total"
            :total="total"
          />
          <el-go
            :page-size="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          ></el-go>
        </el-col>
      </el-row>
    </el-tab-pane>
    <el-tab-pane label="数字证书与模板绑定的授权" name="second" v-if="accountInfoVO.digitalCertificateSwitch">
      <digital></digital>
    </el-tab-pane>
    <el-tab-pane label="授权给我的" name="three" v-if="currentAuthUser.userType !== 0">
      <template v-if="ListAndStatistics">
<!--        搜索-->
        <div class="search_box">
          <el-select style="width: 130px" v-model="optionsValue1" placeholder="请选择" size="small">
            <el-option
              v-for="item in optionsList1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input style="width: 250px; margin: 0 10px" size="small" v-model="inputValue1"></el-input>
          <el-select style="width: 100px" v-model="optionsValue2" placeholder="请选择" size="small">
            <el-option
              v-for="item in optionsList2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px" size="small" @click="getAuthList1">查询</el-button>
          <el-button @click="resetAuthList1" size="small">重置</el-button>
        </div>
        <el-table
          v-loading="tableLading"
          :data="tableData1"
          style="border: 1px solid #eeeeee; border-bottom: 0"
          tooltip-effect="dark"
          :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '600',
              }"
        >
          <el-table-column
            prop="grantorUserName"
            label="授权人名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="grantorAccount"
            label="授权账号">
          </el-table-column>
          <el-table-column
            prop="grantorIdNo"
            label="授权人证件号">
          </el-table-column>
          <el-table-column
            prop="grantTime"
            label="授权时间">
          </el-table-column>
          <el-table-column
            prop="scopes"
            label="授权范围">
            <template slot-scope="scope">
              企业基本信息、申请数字证书、发起/签署合同、存储合同文件、管理并使用AppKey
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button v-if="scope.row.hasAppkey" type="text" size="small" class="link-option" @click="statisticsList(scope.row)">查看套餐用量</el-button>
              <el-button style="margin-left: 0" type="text" size="small" class="link-option" @click="handleLift(scope.row, 'bb')">解除授权关系</el-button>
            </template>
          </el-table-column>
          <no-data text="暂无数据" slot="empty" />
        </el-table>
        <!--分页-->
        <el-row class="pageation row">
          <el-col :span="24" class="page-flex-end">
            <el-pagination
              @current-change="handleCurrentChange1"
              :current-page="page1"
              :page-size="pageSize1"
              layout="prev, pager, next, total"
              :total="total1"
            />
            <el-go
              :page-size="pageSize1"
              :total="total1"
              @current-change="handleCurrentChange1"
            ></el-go>
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <app-key :ifAppKey="false" :grantorUserId="grantorUserId">
          <template #sss>
            <el-button size="mini" type="primary" @click="ListAndStatistics = true">返回</el-button>
          </template>
        </app-key>
      </template>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { ApiMethods } from "../../../../assets/js/http-serve/http-methods";
import { mapGetters } from "vuex";
import ElGo from "../../../../components/go/Go";
import digital from '../../../signSettings/digital';
import appKey from "../APPKey.vue";

  export default {
    name:'accAuthList',
    components: { ElGo , digital, appKey}, // 注册组件
    data () {
      // 这里存放数据
      return {
        activeName: 'first',
        tableData: [],
        tableLading:false,
        page: 1,
        pageSize: 10,
        total:0,
        //---查询bb授权列表
        optionsValue1: '',
        optionsList1: [
          { value: '1', label: '授权人名称'},
          { value: '2', label: '授权人账号'},
          { value: '3', label: '授权人证件号'},
        ],
        inputValue1: '',
        optionsValue2: '',
        optionsList2: [
          { value: '0', label: '个人'},
          { value: '1', label: '企业'},
        ],
        //bb授权列表
        tableData1: [],
        page1: 1,
        pageSize1: 10,
        total1:0,
        //套餐页面
        ListAndStatistics: true,
        grantorUserId: '',
      }
    },
    // 监听属性 类似于data概念
    computed: {
      ...mapGetters(["allAuthUser", "currentAuthUser"]),
      accountInfoVO () {
        const allAuthUser = this.$store.getters.allAuthUser;
        if (allAuthUser && allAuthUser.accountInfoVO) {
          return allAuthUser.accountInfoVO;
        }
        return {};
      },
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      /** 翻页CurrentChange */
      handleCurrentChange (val) {
        this.page = val;
        this.getAuthList();
      },
      /** 翻页CurrentChange */
      handleCurrentChange1 (val) {
        this.page1 = val;
        this.getAuthList1();
      },
      /** 解除授权 */
      handleLift(row, user) {
        const TITLE = '系统提示',_this=this;
        let CONTENT= user === 'bb' ? '解除授权关系后，您将与该用户解除关联关系，是否确认？' : '确认解除授权？'
        _this.$confirm(
          CONTENT,TITLE,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          if (user === 'bb') {
            ApiMethods.IdenAuthController.userAuthCancel1({grantorUserId:row.grantorUserId}).then(res=>{
              if(!res.success) return this.$message.error(res.description);
              this.$message.success(res.description);
              this.getAuthList1();
            })
          } else {
            ApiMethods.IdenAuthController.userAuthCancel({granteeUserId:row.granteeUserId}).then(res=>{
              if(!res.success) return this.$message.error(res.description);
              this.$message.success(res.description);
              this.getAuthList();
            })
          }
        })
        .catch(() => { console.log('取消解除授权') });
      },
      /** 获取授权列表 */
      getAuthList() {
        const {page,pageSize} = this;
        this.tableLading = true;
        ApiMethods.IdenAuthController.userAuthList({page,pageSize}).then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.tableData = res.data || [];
          this.page=page;
          this.total= res.total
        }).finally(() => {this.tableLading = false;});
      },
      /** 获取bb授权列表 */
      getAuthList1() {
        const {page1,pageSize1} = this;
        this.tableLading = true;
        let param = {
          page: page1,
          pageSize: pageSize1,
          name: this.optionsValue1 === '1' ? this.inputValue1 : '',
          account: this.optionsValue1 === '2' ? this.inputValue1 : '',
          idNo: this.optionsValue1 === '3' ? this.inputValue1 : '',
          userType: this.optionsValue2,
        }
        ApiMethods.IdenAuthController.granteePage(param).then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.tableData1 = res.data || [];
          this.page1 = page1;
          this.total1 = res.total
        }).finally(() => {this.tableLading = false;});
      },
      //重置bb授权列表参数
      resetAuthList1() {
        this.optionsValue1 = '';
        this.optionsValue2 = '';
        this.inputValue1 = '';
        this.getAuthList1();
      },
      //获取bb授权统计
      statisticsList(row) {
        this.grantorUserId = row.grantorUserId;
        this.ListAndStatistics = false; //切换到套餐页面
      },
      loadingStart() {
        this.loading = this.$loading()
      },
      loadingColse() {
        if(this.loading) this.loading.close();
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {
      this.getAuthList();
      this.getAuthList1();
    },
  }
</script>

<style lang='less' scoped>
  // @import url(); 引入公共css类
  /deep/ .el-tabs__nav-scroll {
    padding: 0 10px;
  }
  .acc-root-sty{
    padding: 5px 10px;
    /*bb授权列表*/
    .search_box {
      margin: 20px 0;
      text-align: right;
      /*display: flex;*/
    }
    .link-option {
      color: #290202;
      font-weight: bold;
    }
    .pageation {
      padding: 30px 10px 20px 10px;
      border-top: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// pages/signSettings/components/account/index.vue